module.exports = __webpack_public_path__ + "img/103043.53bf38eb.png";